import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var Url = /*#__PURE__*/function () {
  function Url() {
    _classCallCheck(this, Url);
  }

  _createClass(Url, [{
    key: "parseQuery",

    /**
     * 解析queryString为query对象
     * @param {*} queryString
     * @returns {Object} query对象
     */
    value: function parseQuery(queryString) {
      var query = {};
      if (!queryString) return query;

      try {
        var quries = queryString.split('&');

        if (quries && quries.length) {
          quries.forEach(function (queryItem) {
            var arr = queryItem.split('=');
            query[arr[0]] = arr[1];
          });
        }

        return query;
      } catch (e) {
        console.log('Parse QueryString Fail', e);
        return query;
      }
    }
    /**
     * 解析HTTP URL
     * @param {URL} url
     * @param {Object} options
     * @returns {Object} 包含uri, hash, query三部分
     */

  }, {
    key: "parseUrl",
    value: function parseUrl(url, options) {
      if (options && options.shouldDecode) {
        url = decodeURIComponent(url);
      }

      var arr1 = url.split('#');
      var hash = arr1.length === 2 ? arr1[1] : undefined;
      url = arr1[0];
      var arr2 = url.split('?');
      var uri = arr2[0];
      var queryString = arr2.length === 2 ? arr2[1] : '';
      var query = this.parseQuery(queryString);
      return {
        uri: uri,
        hash: hash,
        query: query
      };
    }
    /**
     *
     * @param {any} url
     * @param {any} options
     * @memberof Url
     * @deprecated
     */

  }, {
    key: "parse",
    value: function parse() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.href;
      var options = arguments.length > 1 ? arguments[1] : undefined;
      return this.parseUrl(url, options);
    }
  }, {
    key: "_stringify",
    value: function _stringify(url, data) {
      if (!data) {
        return url;
      }

      var param = [];

      for (var o in data) {
        //  过滤未复制变量
        if (data.hasOwnProperty(o) && data[o] !== undefined) {
          param.push(o + '=' + data[o]);
        }
      } //  _fb_参数格式化


      if (!url) {
        return param.join('&');
      } else {
        return ~url.indexOf('?') ? url + '&' + param.join('&') : url + '?' + param.join('&');
      }
    }
    /**
     * HTTP URL序列化
     * @param {*} uri
     * @param {*} query
     * @param {*} hash
     * @returns {URL}
     */

  }, {
    key: "stringify",
    value: function stringify(uri, query, hash) {
      var url = this._stringify(uri, query);

      if (hash) {
        url += '#' + hash;
      }

      return url;
    }
  }, {
    key: "query2Object",
    value: function query2Object(url, options) {
      url = url || location.href;
      return this.parse(url, options).query || {};
    }
  }, {
    key: "getQuery",
    value: function getQuery(name) {
      var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : location.href;
      var options = arguments.length > 2 ? arguments[2] : undefined;
      return (this.query2Object(url, options) || {})[name] || undefined;
    }
  }, {
    key: "getHashQuery",
    value: function getHashQuery(name) {
      var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : location.href;
      var arrLength = url.split('?').length;

      if (arrLength > 1) {
        var arrLast = url.split('?')[arrLength - 1];
        return (this.parseQuery(arrLast) || {})[name] || undefined;
      }
    }
  }]);

  return Url;
}();

export default new Url();